export const NotFoundIcon = () => (
	<svg
		width="9rem"
		height="5.7rem"
		viewBox="0 0 90 57"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M45.3971 44.6028C57.4377 44.6028 67.1985 34.842 67.1985 22.8014C67.1985 10.7608 57.4377 1 45.3971 1C33.3565 1 23.5957 10.7608 23.5957 22.8014C23.5957 34.842 33.3565 44.6028 45.3971 44.6028Z"
			fill="#F3F6FA"
			stroke="#14489D"
			strokeWidth="1.62697"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M41.9039 39.7179C43.0484 39.9292 44.2129 40.039 45.3972 40.0473C54.9219 40.0473 62.6431 32.3261 62.6431 22.8014C62.6431 13.2768 54.9219 5.55554 45.3972 5.55554C42.9505 5.55554 40.6228 6.06506 38.5144 6.98379C34.8505 8.58032 31.8489 11.4126 30.036 14.9541C28.8311 17.3081 28.1514 19.9754 28.1514 22.8014C28.1514 25.3655 28.7109 27.7989 29.7147 29.9862C30.4312 31.5477 31.3742 32.9838 32.5015 34.2524"
			fill="white"
		/>
		<path
			d="M41.9039 39.7179C43.0484 39.9292 44.2129 40.039 45.3972 40.0473C54.9219 40.0473 62.6431 32.3261 62.6431 22.8014C62.6431 13.2768 54.9219 5.55554 45.3972 5.55554C42.9505 5.55554 40.6228 6.06506 38.5144 6.98379C34.8505 8.58032 31.8489 11.4126 30.036 14.9541C28.8311 17.3081 28.1514 19.9754 28.1514 22.8014C28.1514 25.3655 28.7109 27.7989 29.7147 29.9862C30.4312 31.5477 31.3742 32.9838 32.5015 34.2524"
			stroke="#14489D"
			strokeWidth="1.62697"
			strokeLinecap="round"
		/>
		<path
			d="M34.5276 36.1909C35.9256 37.3271 37.5049 38.2488 39.2155 38.9059"
			stroke="#14489D"
			strokeWidth="1.62697"
			strokeLinecap="round"
		/>
		<path d="M63.2939 40.0473L67.1987 43.952" stroke="#14489D" strokeWidth="1.62697" />
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M66.5674 43.3201C65.3356 44.5518 65.3356 46.5489 66.5674 47.7806L73.7815 54.9948C75.0133 56.2266 77.0104 56.2266 78.2421 54.9948C79.4739 53.7631 79.4739 51.766 78.2421 50.5342L71.028 43.3201C69.7962 42.0883 67.7991 42.0883 66.5674 43.3201Z"
			fill="#ECF3FD"
			stroke="#14489D"
			strokeWidth="1.62697"
		/>
		<path
			d="M69.8018 44.6028L76.9604 51.7614"
			stroke="white"
			strokeWidth="1.62697"
			strokeLinecap="round"
		/>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M41.1673 15.3177C41.1673 22.8655 47.286 28.9843 54.8339 28.9843C56.3166 28.9843 57.7442 28.7481 59.081 28.3114C56.8989 33.7266 51.5946 37.5491 45.3974 37.5491C37.2527 37.5491 30.6501 30.9465 30.6501 22.8018C30.6501 15.4215 36.0714 9.30751 43.149 8.22479C41.8916 10.2931 41.1673 12.7208 41.1673 15.3177Z"
			fill="#ECF3FD"
		/>
		<path
			d="M45.7226 10.7618C44.8939 10.7618 44.0843 10.8434 43.3012 10.9988M40.9359 11.7225C36.484 13.5933 33.3577 17.995 33.3577 23.1268"
			stroke="#4587E8"
			strokeWidth="1.62697"
			strokeLinecap="round"
		/>
		<path
			d="M80.3287 22.9819H75.008M84.4444 17.9205H73.2666H84.4444ZM88.9999 17.9205H87.5544H88.9999Z"
			stroke="#4587E8"
			strokeWidth="1.62697"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<path
			d="M21.7582 37.2992H16.4375M18.7152 31.587H7.53743H18.7152ZM3.7471 31.587H1H3.7471Z"
			stroke="#4587E8"
			strokeWidth="1.62697"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
